import React, { useState } from 'react';
import styles from '../styles/CreateRoomModal.module.scss';
import { toast } from "react-toastify";

export default function CreateEntityModal({
                                              title,
                                              placeholder,
                                              onClose,
                                              onSave,
                                              secondInput = false,
                                              secondPlaceholder,
                                              checkboxes = [],
                                          }) {
    const [name, setName] = useState('');
    const [secondValue, setSecondValue] = useState('');
    const [checkboxValues, setCheckboxValues] = useState(
        checkboxes.reduce((acc, item) => {
            acc[item.name] = !!item.defaultValue;
            return acc;
        }, {})
    );
    const [saving, setSaving] = useState(false);

    const handleCheckboxChange = (name, checked) => {
        setCheckboxValues(prev => ({
            ...prev,
            [name]: checked,
        }));
    };

    const handleSubmit = async () => {
        if (!name.trim()) {
            toast.error('Поле не может быть пустым');
            return;
        }

        setSaving(true);
        try {
            if (secondInput) {
                await onSave(name, secondValue, checkboxValues);
            } else {
                await onSave(name, checkboxValues);
            }

            onClose();
        } catch (e) {
            console.error(e);
            const errorMessage = e?.response?.data?.message || 'Ошибка при создании';
            toast.error(errorMessage);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h5>{title}</h5>
                    <button onClick={onClose} className={styles.closeBtn}>×</button>
                </div>

                <input
                    className="form-control mb-3"
                    placeholder={placeholder}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                    autoFocus
                />

                {secondInput && (
                    <input
                        className="form-control mb-3"
                        placeholder={secondPlaceholder}
                        value={secondValue}
                        onChange={(e) => setSecondValue(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                    />
                )}

                {checkboxes.map((item) => (
                    <div className="form-check form-switch mb-3" key={item.name}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`checkbox-${item.name}`}
                            checked={!!checkboxValues[item.name]}
                            onChange={(e) => handleCheckboxChange(item.name, e.target.checked)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor={`checkbox-${item.name}`}
                        >
                            {item.label}
                        </label>
                    </div>
                ))}

                <button
                    className="service-btn w-100"
                    onClick={handleSubmit}
                    disabled={saving}
                >
                    {saving ? 'Сохранение...' : 'Сохранить'}
                </button>
            </div>
        </div>
    );
}